import React from "react";
import { Application } from "../types/BaseTypes";
import Arrow from "../images/arrow";

export default (props: { other: Application; home: Boolean }) => {
  const { other, home } = props;

  const switchApplication = () => {
    return other === Application.LessThanOnePerson
      ? "Other Applications - <1 person per 10m²"
      : other === Application.HumanComfort
      ? "Human Comfort"
      : "Other Applications - Above Ground";
  };

  return (
    <div
      className="title-bar"
      style={{
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "center",
        marginTop: 30,
      }}
    >
      Opteon™ XL Refrigerant Charge Calculator {!home && <Arrow />}{" "}
      {!home && switchApplication()}
      {home && <br />}
      {home && (
        <span style={{ fontSize: 16, fontWeight: 300 }}>
          Choose the location, access categories and preferred refrigerant. Type
          in the room dimensions and estimated refrigerant charge.
        </span>
      )}
      {home && (
        <span style={{ fontSize: 13, fontWeight: 600 }}>
          <br />
          The calculator is optimized for desktop use on Google Chrome.
        </span>
      )}
    </div>
  );
};
